import { SpinBoundaryEndActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { FeatureHudPresenter } from "./FeatureHudPresenter";

/** The feature HUD (spins remaining, accumulated win): every feature state, plus the count-up at a spin end. */
export function createFeatureHudPlugin(deps: { presenter: FeatureHudPresenter }): ReplayPlugin {
  return {
    name: "feature-hud",
    actionHandlers: [
      new SpinBoundaryEndActionHandler(async () => {
        void deps.presenter.runPendingCountUp();
      }),
    ],
    observer: {
      onFeatureState: async (event) => {
        const featureState = event.eventContent.featureState;
        if (!featureState) return;
        await deps.presenter.applyFeatureState({
          featureIdentifier: featureState.featureIdentifier,
          featurePhase: featureState.featurePhase,
          featureCountRemaining: featureState.featureCountRemaining,
          featureAccumulatedWinMinor: featureState.featureAccumulatedWinMinor,
        });
      },
    },
  };
}
